export const ERROR_MESSAGE_KEYS = {
  unknown: "errors.unknown",
  network: "errors.network",
  backend: "errors.backend"
} as const

export type ErrorMessageKey =
  (typeof ERROR_MESSAGE_KEYS)[keyof typeof ERROR_MESSAGE_KEYS]

const errorMessageKeys = new Set<string>(Object.values(ERROR_MESSAGE_KEYS))

export const isErrorMessageKey = (value: unknown): value is ErrorMessageKey =>
  typeof value === "string" && errorMessageKeys.has(value)
